//请自行添加语言资源
const carrierAging = {

  itrCode:'ITR',
  orderTypeName:'订单类型',
  carrierNo: '承运商编码',
  carrierName: '承运商名称',
  consigneeCode: '收货方编码',
  consigneeAddrShort:'收货工厂',
  expectedDeliveryDate:'客户要求到货日期',
  epodUploadTime:'EPOD回传时间',

  truckNo:'车牌号',
  planExpToTime:'车辆预约时间',
  inTime:'车辆入库时间',
  outTime: '车辆出库时间',
  planExpDiffDay:'预约时间差(天)',
  actArriveTime:'实际到货日期',
  actArriveDiffDay:'实际到货差异(天)',
  epodUploadDiffDay:'EPOD回传时间差(天)',

  msg:{

  }
};
export default carrierAging



// WEBPACK FOOTER //
// ./src/page/report/carrierAging/lang/carrierAging.zh.js